export default {
  GET_VIDEO_CONFIGURATION_BEGIN: 'GET_VIDEO_CONFIGURATION_BEGIN',
  GET_VIDEO_CONFIGURATION_SUCCESS: 'GET_VIDEO_CONFIGURATION_SUCCESS',
  GET_VIDEO_CONFIGURATION_FAILURE: 'GET_VIDEO_CONFIGURATION_FAILURE',  
  SET_VIDEO_V2_CONFIGURATION: 'SET_VIDEO_V2_CONFIGURATION',
  SET_VIDEO_V2_CONFIGURATION_FAILURE: 'SET_VIDEO_V2_CONFIGURATION_FAILURE',
  SET_VIDEO_CREATOR_LOAD_SUCCESS: 'SET_VIDEO_CREATOR_LOAD_SUCCESS',
  SET_VIDEO_CREATOR_LOAD_FAILURE: 'SET_VIDEO_CREATOR_LOAD_FAILURE',
  SET_VIDEO_PLAYER_LOAD_SUCCESS: 'SET_VIDEO_PLAYER_LOAD_SUCCESS',
  SET_VIDEO_PLAYER_LOAD_FAILURE: 'SET_VIDEO_PLAYER_LOAD_FAILURE',
};